import type { ChannelTypeEnum } from '@shared/api';

export type ChannelCreatableType = Extract<
  ChannelTypeEnum,
  'telegram_bot' | 'telegram' | 'widget' | 'vk_bot' | 'max_bot' | 'avito'
>;

export type ChannelCreateRouteType =
  | 'telegram-bot'
  | 'telegram'
  | 'widget'
  | 'vk-bot'
  | 'max-bot'
  | 'avito';

const CHANNEL_ROUTE_BY_TYPE: Record<ChannelCreatableType, ChannelCreateRouteType> = {
  telegram_bot: 'telegram-bot',
  telegram: 'telegram',
  widget: 'widget',
  vk_bot: 'vk-bot',
  max_bot: 'max-bot',
  avito: 'avito',
};

const CHANNEL_TYPE_BY_ROUTE: Record<ChannelCreateRouteType, ChannelCreatableType> = {
  'telegram-bot': 'telegram_bot',
  telegram: 'telegram',
  widget: 'widget',
  'vk-bot': 'vk_bot',
  'max-bot': 'max_bot',
  avito: 'avito',
};

export const toChannelCreateRouteType = (type: ChannelCreatableType) => CHANNEL_ROUTE_BY_TYPE[type];

export const toChannelTypeFromRoute = (type?: string): ChannelCreatableType | null => {
  if (!type) return null;
  return CHANNEL_TYPE_BY_ROUTE[type as ChannelCreateRouteType] ?? null;
};
